import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";

const PostDetailStats = ({ 
    likesCount, 
    commentCount,
    isLiked, 
    isLoadingLikes, 
    onLike, 
    onShare,
    onTipClick, 
    isTipping, 
    hasWallet 
}) => {
    return (
        <div className="info">
            <div className="items">
                {isLoadingLikes ? (
                    "..."
                ) : isLiked ? (
                    <FavoriteOutlinedIcon
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={onLike}
                    />
                ) : (
                    <FavoriteBorderOutlinedIcon
                        style={{ cursor: "pointer" }}
                        onClick={onLike}
                    />
                )}
                {likesCount} likes
            </div>

            <div className="items">
                <TextsmsOutlinedIcon />
                {commentCount} comments
            </div>

            <div 
                className="items" 
                onClick={onShare} 
                style={{ cursor: "pointer" }}
            >
                <ShareOutlinedIcon />
                shares
            </div>

            {/* Test */}        
            {/* <div 
                className="item" 
                onClick={onTipClick}
                style={{ 
                    color: hasWallet ? "#f6851b" : "gray", 
                    cursor: isTipping ? "wait" : "pointer" 
                }}
            >
                <PaidOutlinedIcon /> 
                {isTipping ? "Processing..." : "Tip"}
            </div> */}

            <div 
                className={`items tip-btn ${hasWallet ? 'has-wallet' : 'no-wallet'} ${isTipping ? 'is-tipping' : ''}`} 
                onClick={hasWallet && !isTipping ? onTipClick : undefined}
            >
                <PaidOutlinedIcon /> 

                {isTipping ? "Processing..." : "Tip"}
            </div>
        </div>
    );
};

export default PostDetailStats;